import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Properties from "@/components/site/Properties";
import ThingsToDo from "@/components/site/ThingsToDo";
import Testimonials from "@/components/site/Testimonials";
import FAQs from "@/components/site/FAQs";
import Contact from "@/components/site/Contact";
import NewsletterSignup from "@/components/site/NewsletterSignup";
import Footer from "@/components/site/Footer";
import PropertyGallery from "@/components/site/PropertyGallery";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import SEO from "@/components/site/SEO";

function HomePage() {
  return (
    <div className="app-shell" data-testid="home-page">
      <SEO
        title="Cheshire Holidays — Cottages & Shepherd's Huts with Hot Tubs"
        description="Luxury Cheshire holiday cottages and hand-built shepherd's huts with wood-fired hot tubs on the River Weaver and near Delamere Forest. Book direct."
        path="/"
      />
      <Navigation />
      <main>
        <Hero />
        <Properties />
        <ThingsToDo />
        <Testimonials />
        <FAQs />
        <NewsletterSignup />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1B3B36",
            color: "#FAF9F6",
            border: "1px solid rgba(250,249,246,0.2)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/oakmere-gallery" element={<PropertyGallery propertyId="oakmere" />} />
          <Route path="/the-hide-gallery" element={<PropertyGallery propertyId="the-hide" />} />
          <Route
            path="/dutton-locks-hut-gallery"
            element={<PropertyGallery propertyId="shepherds-hut-dutton" />}
          />
          <Route
            path="/acton-bridge-gallery"
            element={<PropertyGallery propertyId="acton-bridge-cottage" />}
          />
          <Route
            path="/lock-keepers-gallery"
            element={<PropertyGallery propertyId="lock-keepers-cottage" />}
          />
          <Route
            path="/oakmere-cottage-gallery"
            element={<PropertyGallery propertyId="oakmere-cottage" />}
          />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <WhatsAppFab />
      </BrowserRouter>
    </HelmetProvider>
  );
}
